export default {
  namespaced: true,
  state: {
    visibleOnboarding: false,
    sequencyOnboarding: 0,
    firstAccess: true,
    visibleOnboardingIntro: true
  },
  mutations: {
    UPDATE_SEQUENCY(state, sequency) {
      state.sequencyOnboarding = sequency
    },
    VISIBLE_ONBOARDING(state, visible) {
      state.visibleOnboarding = visible
    },
    SET_VISIBLE_ONBOARDING_INTRO(state, visible) {
      state.visibleOnboardingIntro = visible
    }
  }
}
